import React from 'react';
import { Modal as ModalSui } from 'semantic-ui-react';
import Form from '../components/Form';
import { setFormAsClosed, formWasSubmitted, formWasClosed } from '../utils/storageUtils';

class Modal extends React.Component {
  constructor(props) {
    super(props);

    this.wasSubmitted = this.wasSubmitted.bind(this);
    this.shouldDisplayModal = this.shouldDisplayModal.bind(this);
    this.hijackCloseEmailCapture = this.hijackCloseEmailCapture.bind(this);
  }

  shouldDisplayModal() {
    const { locationId, isVisible } = this.props;
    const wasClosed = formWasClosed(locationId);
    const wasSubmitted = this.wasSubmitted();

    if (!isVisible) {
      return false;
    }

    if (wasClosed || wasSubmitted) {
      return false;
    }

    return true;
  }

  wasSubmitted() {
    const { locationId, isSuccess } = this.props;
    return formWasSubmitted(locationId) || isSuccess;
  }

  hijackCloseEmailCapture(quickClose = false) {
    const { closeEmailCapture, locationId, closeDelay } = this.props;
    setFormAsClosed(locationId);

    if (quickClose) {
      closeEmailCapture(0);
    } else {
      closeEmailCapture(closeDelay * 1000);
    }
  }

  render() {
    const { onClose, image } = this.props;
    const shouldDisplayModal = this.shouldDisplayModal();
    let size = 'tiny';
    if (image && ['left', 'right'].includes(image.placement)) {
      size = 'large';
    }
    return (
      <>
        <ModalSui open={shouldDisplayModal} onClose={onClose} dimmer="inverted" size={size}>
          <Form {...this.props} closeEmailCapture={this.hijackCloseEmailCapture} />
        </ModalSui>
      </>
    );
  }
}

export default Modal;
